import { CBTProgramState } from 'src/modules/programs/cbtProgram/models/cbtProgram';
import { CPProgramState } from 'src/modules/programs/cpProgram/models/cpProgram';
import { FeedbackState } from 'src/modules/programs/feedback/models/feedback';
import { ProgramsState } from 'src/modules/programs/models/programs';
import { PFAProgramState } from 'src/modules/programs/pfaProgram/models/pfaProgram';
import { SurveysState } from 'src/modules/programs/surveys/models/surveys';
import { VideosState } from 'src/modules/videos/models/Videos';

// LEGACY: to be removed after migrating over to redux-rematch
export enum Reducer {
    Who5 = 'who5',
    Videos = 'videos',
    Programs = 'programs',
    Surveys = 'surveys',
    Feedback = 'feedbacks',
}

// LEGACY: to be removed after migrating over to redux-rematch
export enum ProgramReducer {
    CPProgram = 'cpProgram',
    PFAProgram = 'pfaProgram',
    CBTProgram = 'cbtProgram',
}

// LEGACY: to be removed after migrating over to redux-rematch
export interface AppState {
    // Modules below shouldn't be migrated over to redux-rematch
    // because we'll most likely implement programs system same as in the mobile so they're going to be deleted anyway
    [Reducer.Videos]: VideosState;
    [Reducer.Programs]: ProgramsState;
    [Reducer.Surveys]: SurveysState;
    [Reducer.Feedback]: FeedbackState;
    [ProgramReducer.CPProgram]: CPProgramState;
    [ProgramReducer.PFAProgram]: PFAProgramState;
    [ProgramReducer.CBTProgram]: CBTProgramState;
}
